import {eventCTA} from "./features/eventCTA";
import {eventFormFilters} from "./features/eventFormFilters";
import {eventRessource} from "./features/eventRessource";
import {eventSocialNetworks} from "./features/eventSocialNetworks";
import {eventContact} from "./features/eventContact";
import {eventProject} from "./features/eventProject";
import {eventNeed} from "./features/eventNeed";

export default () => {
    eventCTA();
    eventFormFilters();
    eventRessource();
    eventSocialNetworks();
    eventContact();
    eventProject();
    eventNeed();
};
